import Vue from 'vue'
import moment from 'vue-moment'

Vue.use(moment)
